module.exports = __webpack_public_path__ + "static/media/Warning.220b35a5.svg";